import { useEffect, useState } from "react";
import http from "../../../http";
import { endpointName } from "../const";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { METER_TYPE } from "config/const";
import { useDispatch, useSelector } from "react-redux";
import { setShowLoading, setShowMassage } from "store/sysSlice";
import { generateFakeMeterReadings } from "./demoData";
import { calculateConsumption, groupBy } from "../../../config/functions";
import moment from "moment";
import ChartWeeklyAverage from "./ChartWeeklyAverage";
import ReadToday from "./ReadToday";
import ChartMonthOrYear from "./ChartMonthOrYear";
import { Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import CheckRole from "components/CheckRole";
import { DEPARTMENT_MANAGER } from "config/roles";
import NullCheck from "components/NullCheck";
import CustomButton from "components/CustomButton";

const MeterRead = () => {
  const theme = useTheme()
  const dispatch = useDispatch()
  const { bt } = useBizTypeTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const biz = useSelector((state) => state?.biz?.data);
  const [data, setData] = useState([]);
  const [list, setList] = useState([]);
  const [selectedMeter, setSelectedMeter] = useState(null);
  const [selectedMonthOrYear, setSelectedMonthOrYear] = useState("Year");
  const [selectedMeterType, setSelectedMeterType] = useState([]);
  const [isRealData, setIsRealData] = useState(true);

  useEffect(() => {
    getmeterRead()
  }, []);

  const getmeterRead = () => {
    dispatch(setShowLoading(true))
    http.get(`${endpointName}/meterRead`)
      .then((res) => {
        if (res?.data?.data.length > 0) {
          setIsRealData(true)
          setList(calculateConsumption(res?.data?.data))
          prepareData(calculateConsumption(res?.data?.data))
        }
        else {
          dispatch(setShowMassage({ massage: "NO_DATA", type: "info" }));

        }
        dispatch(setShowLoading(false))
      })
      .catch((error) => dispatch(setShowLoading(false)));
  }

  const getFakeMeterReadings = () => {
    if (biz?.isExample) {
      setIsRealData(false)
      const fakeData = generateFakeMeterReadings("667d03741be3684e2f96787d", "ישראל ישראלי", 2540);
      setList(calculateConsumption(fakeData))
      prepareData(calculateConsumption(fakeData))
    }
  }

  const prepareData = (data) => {
    let meters = []
    const groupByMeter = groupBy(data, 'meter.id')
    Object.keys(groupByMeter)?.map(key => {
      const meterList = groupByMeter[key]
      let item = {
        id: groupByMeter[key][0]?.meter?.id,
        name: groupByMeter[key][0]?.meter?.name,
        type: groupByMeter[key][0]?.meter?.type,
        consumptionThisMonth: [],
        consumptionLastMonth: [],
        consumptionLasWeekly: [],
        consumptionThisMonthLastYear: [],
        hasReadToDay: false
      }

      const thisMonth = moment().month();
      const lastMonth = moment().subtract(1, 'month').month();
      const thisYear = moment().year();
      const lastYear = moment().subtract(1, 'year').year();
      const ListByType = meterList?.filter(m => m?.meter?.type === groupByMeter[key][0]?.meter?.type)
      const maxArry = getMaxYArry(ListByType)
      item.consumptionLasWeekly = calculateWeeklyAverages(ListByType, 'consumption')
      item.consumptionThisMonth = getMonthlyConsumptionData(ListByType, thisMonth + 1, thisYear, maxArry)
      item.consumptionLastMonth = getMonthlyConsumptionData(ListByType, lastMonth + 1, thisYear, maxArry)
      item.consumptionThisMonthLastYear = getMonthlyConsumptionData(ListByType, thisMonth + 1, lastYear, maxArry)
      item.maxYArry = maxArry

      meterList?.map(read => {
        /** Check If Has Read Today */
        if (moment(read.created).startOf('day').isSame(moment().startOf('day')))
          item.hasReadToDay = true
      })
      meters.push(item)
    })

    const electricityMeters = meters.filter(m => m?.type === METER_TYPE.ELECTRICITY)
    const waterMeters = meters.filter(m => m?.type === METER_TYPE.WATER)
    const gasMeters = meters.filter(m => m?.type === METER_TYPE.GAS)
    const chlorineMeters = meters.filter(m => m?.type === METER_TYPE.CHLORINE)

    const initData = {
      meters,
      electricityMeters,
      waterMeters,
      gasMeters,
      chlorineMeters,
    }

    setSelectedMeter(meters[0])
    selectMeterType(METER_TYPE.ELECTRICITY, initData)
    setData(initData)
  }

  const calculateWeeklyAverages = (data, key) => {
    const now = new Date();
    const currentMonth = now.getMonth();  // חודש נוכחי (0-11)
    const currentYear = now.getFullYear(); // שנה נוכחית

    const weeklyAverages = []

    // סינון נתונים לחודש והשנה הנוכחיים
    const filteredData = data.filter(item => {
      const itemDate = new Date(item.created);
      return itemDate.getMonth() === currentMonth && itemDate.getFullYear() === currentYear;
    });

    // מיון התאריכים לפי סדר כרונולוגי
    filteredData.sort((a, b) => new Date(a.created) - new Date(b.created));

    // אוגרים ערכי צריכה לכל שבוע
    const weekData = [[], [], [], [], []];

    filteredData.forEach(item => {
      const itemDate = new Date(item.created);
      const weekNumber = Math.floor((itemDate.getDate() - 1) / 7); // חישוב מספר השבוע
      if (weekNumber >= 0 && weekNumber < 5) {
        weekData[weekNumber].push(Number(item[key]) || 0);
      }
    });

    // חישוב ממוצע לכל שבוע
    weekData.forEach((values, index) => {
      if (values.length > 0) {
        weeklyAverages[index] = parseFloat(values.reduce((sum, value) => sum + value, 0) / values.length).toFixed(2);
      }
    });

    return weeklyAverages;
  };

  const getMaxYArry = (records) => {
    const lastRecordDate = records.reduce((latest, record) => {
      let recordDate = moment(record.created);
      return recordDate.isAfter(latest) ? recordDate : latest;
    }, moment(0));

    return lastRecordDate.date();
  }

  const getMonthlyConsumptionData = (records, month, year, maxArry) => {
    const result = Array(maxArry).fill(0);
    records.forEach(record => {
      const date = new Date(record.created);
      if (date.getMonth() + 1 === month && date.getFullYear() === year) {
        const day = date.getDate();
        if (day <= maxArry) {
          result[day - 1] += record.consumption;
        }
      }
    });

    return result;
  };

  const selectMeterType = (id, list) => {
    const initList = list ?? data
    let newList = []
    if (id === METER_TYPE.ELECTRICITY)
      newList = {
        type: METER_TYPE.ELECTRICITY,
        list: initList?.electricityMeters,
        qty: initList?.electricityMeters.length + 1
      }
    else if (id === METER_TYPE.WATER)
      newList = {
        type: METER_TYPE.WATER,
        list: initList?.waterMeters,
        qty: initList?.waterMeters.length + 1
      }
    else if (id === METER_TYPE.GAS)
      newList = {
        type: METER_TYPE.GAS,
        list: initList?.gasMeters,
        qty: initList?.gasMeters.length + 1
      }
    else if (id === METER_TYPE.CHLORINE)
      newList = {
        type: METER_TYPE.CHLORINE,
        list: initList?.chlorineMeters,
        qty: initList?.chlorineMeters.length + 1
      }
    setSelectedMeterType(newList)
  }

  if (data?.length === 0) {
    return (
      <Stack
        width="100%"
        spacing={1}
        height='50vh'
        justifyContent='center'
        alignItems='center'
      >
        <Typography variant="h6">{bt('NO_DATA')}</Typography>
        <NullCheck valueForCheck={biz?.isExample}>
          <CustomButton title='FAKE_DATA' onClick={getFakeMeterReadings} />
        </NullCheck>
      </Stack>
    )
  };

  return (
    <Stack width='100%' spacing={1}>

      <NullCheck valueForCheck={biz?.isExample}>
        <Stack direction='row' spacing={1}>
          <CustomButton
            title='REAL_DATA'
            onClick={getmeterRead}
            variant={isRealData ? 'contained' : 'outlined'}
          />
          <CustomButton
            title='FAKE_DATA'
            onClick={getFakeMeterReadings}
            variant={!isRealData ? 'contained' : 'outlined'}
          />
        </Stack>
      </NullCheck>

      <Stack width='100%' direction={isMobile ? 'column' : "row"} spacing={1}>
        <ReadToday data={data} />

        <CheckRole role={DEPARTMENT_MANAGER}>
          <ChartWeeklyAverage
            selectedMeter={selectedMeter}
            selectedMeterType={selectedMeterType}
            selectMeterType={selectMeterType}
          />
        </CheckRole>
      </Stack>

      <CheckRole role={DEPARTMENT_MANAGER}>
        <ChartMonthOrYear
          selectedMonthOrYear={selectedMonthOrYear}
          setSelectedMonthOrYear={setSelectedMonthOrYear}
          data={data}
          selectedMeter={selectedMeter}
          setSelectedMeter={setSelectedMeter}
        />
      </CheckRole>
    </Stack>
  );
};
export default MeterRead;
